module.exports = __webpack_public_path__ + "img/kjsy_gallery10.200e9c53.jpg";